import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import PersonApplicationStatusService from "../../src/Services/PersonApplicationStatus.service";
const PersonApplicationStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        labelKey: "applicationStatusName",
        fetchItemsById: (ids) => {
            return PersonApplicationStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return PersonApplicationStatusService.search({
                active: true,
                query: search,
            }).then((resp) => resp.data);
        },
        optionRenderer: function optionRenderer(personApplicationStatus) {
            return _jsx("span", { children: personApplicationStatus.applicationStatusName });
        },
    });
};
export default PersonApplicationStatusLookup;
